import { z } from 'zod';

export const HardwareDrillPatternSchema = z.object({
  id: z.string().uuid(),
  hardware_id: z.string().uuid(),
  pattern_name: z.string().default('Default'),
  target_panel: z.string().default('door'),
  holes_json: z.string().default('[]'),
  units: z.string().default('mm'),
  notes: z.string().nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateHardwareDrillPatternSchema = z.object({
  hardware_id: z.string().uuid(),
  pattern_name: z.string().default('Default'),
  target_panel: z.string().default('door'),
  holes_json: z.string().default('[]'),
  units: z.string().default('mm'),
  notes: z.string().nullable().optional(),
});

export const UpdateHardwareDrillPatternSchema = CreateHardwareDrillPatternSchema.omit({ hardware_id: true }).partial();

export type HardwareDrillPattern = z.infer<typeof HardwareDrillPatternSchema>;
export type CreateHardwareDrillPattern = z.infer<typeof CreateHardwareDrillPatternSchema>;
export type UpdateHardwareDrillPattern = z.infer<typeof UpdateHardwareDrillPatternSchema>;
